/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { VoiceLoadCarrierChangeRequest } from '../../models/voice-load-carrier-change-request';
import { VoiceLoadCarrierChangeResponse } from '../../models/voice-load-carrier-change-response';

export interface ChangeVoiceSessionLoadCarriers$Params {
  organizationSiteKey: KeyType;
  voiceSessionKey: KeyType;
      body: VoiceLoadCarrierChangeRequest
}

export function changeVoiceSessionLoadCarriers(http: HttpClient, rootUrl: string, params: ChangeVoiceSessionLoadCarriers$Params, context?: HttpContext): Observable<StrictHttpResponse<VoiceLoadCarrierChangeResponse>> {
  const rb = new RequestBuilder(rootUrl, changeVoiceSessionLoadCarriers.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('voiceSessionKey', params.voiceSessionKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VoiceLoadCarrierChangeResponse>;
    })
  );
}

changeVoiceSessionLoadCarriers.PATH = '/organization-sites/{organizationSiteKey}/voice-sessions/{voiceSessionKey}/load-carriers';
